export const SET_VENDORPROMOS = 'SET_VENDORPROMOS';
export const GET_VENDORPROMOS = 'GET_VENDORPROMOS';
export const REFRESH_VENDORPROMOS = 'REFRESH_VENDORPROMOS';
export const APPROVE_VENDORPROMOS = 'APPROVE_VENDORPROMOS';
export const EDIT_VENDORPROMOS = 'EDIT_VENDORPROMOS';
export const REJECT_VENDORPROMOS = 'REJECT_VENDORPROMOS';
